<div class="row container">
    <div class="col-xl-12 header" *ngIf="title">{{ title }}</div>
    <div class="col-xl-12 chartContainer" #containerPieChart></div>
  </div>
  